"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitMeterReading = void 0;
var nebula_1 = require("@ovotech/nebula");
var ui_tools_1 = require("@ovotech/ui-tools");
var date_fns_1 = require("date-fns");
var react_1 = __importStar(require("react"));
var screen_reader_route_manager_1 = __importDefault(require("screen-reader-route-manager"));
var legacy_queries_1 = require("../../../../shared/api/legacy-queries");
var core_1 = require("../../../../shared/core");
var MeterReadingsContext_1 = require("../../MeterReadingsContext");
var analytics_subjects_1 = require("../../analytics-subjects");
var components_1 = require("../../components");
var ElectricityMeterReadingFormLegacy_1 = require("../../components/ElectricityMeterReadingFormLegacy");
var GasMeterReadingFormLegacy_1 = require("../../components/GasMeterReadingFormLegacy");
var MeterHelp_1 = require("../../components/MeterHelp/MeterHelp");
var copy_1 = require("../../copy");
var section_ids_1 = require("../../section-ids");
var utils_1 = require("../../utils");
var ButtonLooksLikeLink_1 = require("./ButtonLooksLikeLink");
var utils_2 = require("./utils");
var howToId = 'how-to';
//Make sure supply.msn is not undefined in parent component.
var SubmitMeterReading = function (_a) {
    var _b, _c;
    var accountId = _a.accountId, supply = _a.supply, selectedFuel = _a.selectedFuel, latestActualReading = _a.latestActualReading, supplyIndex = _a.supplyIndex;
    var navigate = (0, ui_tools_1.useNavigate)();
    var _d = (0, react_1.useContext)(MeterReadingsContext_1.MeterReadingsContext), supplies = _d.supplies, readings = _d.readings;
    var _e = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _e.copy, Copy = _e.Copy;
    var _f = (0, core_1.useLinks)(), meterReads = _f.meterReads, meterReadsConfirmation = _f.meterReadsConfirmation;
    var _g = (0, core_1.useComponents)(), ErrorNotification = _g.ErrorNotification, ErrorSummaryNotification = _g.ErrorSummaryNotification, Card = _g.Card, Margin = _g.Margin, Heading1 = _g.Heading1, P = _g.P, Pii = _g.Pii, Stack = _g.Stack, Redirect = _g.Redirect, SummaryList = _g.SummaryList, SummaryItem = _g.SummaryItem;
    // use a local variable, not state or context
    // due to query callbacks, state/context don't get updated in time
    // we can pass a local variable around to check in submission callback
    var hasImgError = false;
    var _h = __read((0, react_1.useState)(null), 2), data = _h[0], setData = _h[1];
    var _j = __read((0, react_1.useState)(), 2), meterPhotoName = _j[0], setMeterPhotoName = _j[1];
    var _k = __read((0, react_1.useState)(false), 2), apiError = _k[0], setApiError = _k[1];
    var _l = __read((0, react_1.useState)(null), 2), apiErrorData = _l[0], setApiErrorData = _l[1];
    var _m = __read((0, react_1.useState)([]), 2), errors = _m[0], setErrors = _m[1];
    var _o = __read((0, react_1.useState)(null), 2), serverSideError = _o[0], setServerSideError = _o[1];
    var dispatch = (0, ui_tools_1.useAnalytics)().dispatch;
    var meterReadingMutation = (0, legacy_queries_1.useManualReadingLegacyMutation)({
        accountId: accountId,
        msn: supply.msn || '',
        mpxn: supply.mpxn,
        fuel: selectedFuel,
        meterType: (0, utils_2.formatMeterType)(supply.rawMeterType || ''),
        force: !!serverSideError,
    }, function () {
        if (data) {
            (0, utils_1.storeLatestReadingLocal)(data.mpxn);
            screen_reader_route_manager_1.default.beforeRouteChange();
            navigate((0, utils_2.getSuccessRedirectLink)(meterReadsConfirmation(), data, selectedFuel, !!serverSideError, false, supplyIndex || 0, hasImgError, data.readingDateTime, supply.msn, meterPhotoName));
        }
        else {
            throw new Error('Submission data not found');
        }
    }, function (error) {
        var _a, _b, _c;
        if (!serverSideError &&
            ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 400 &&
            ((_b = error.response.data) === null || _b === void 0 ? void 0 : _b.errors) &&
            (0, utils_2.allErrorsExpected)(error.response.data.errors)) {
            setApiErrorData(error.response.data.errors);
            var errorCode = (_c = error.response.data.errors[0]) === null || _c === void 0 ? void 0 : _c.errorCode;
            if (!errorCode) {
                console.warn('Error code was null', error.response);
            }
            setServerSideError(errorCode);
        }
        else {
            // If we fail after showing a server side error, or we get any
            // unexpected error, show the generic error.
            setApiError(true);
        }
    });
    var resetErrors = function () {
        setServerSideError(null);
        setApiError(false);
    };
    var submit = function (localHasImgError) {
        if (localHasImgError === void 0) { localHasImgError = false; }
        // use this local var to pass to confirmation page
        // eslint-disable-next-line react-hooks/exhaustive-deps
        hasImgError = localHasImgError;
        if (data && meterReadingMutation.status !== 'in-progress') {
            setApiError(false);
            meterReadingMutation.mutate(data);
        }
    };
    (0, react_1.useEffect)(submit, [data]);
    var handleElectricitySubmit = function (elecData) {
        var _a, _b;
        var _c;
        setErrors([]);
        var lastMexDate = (_c = (0, utils_1.getLatestMeterExchangeReading)(readings['electricity'])) === null || _c === void 0 ? void 0 : _c.readingDateTime;
        var dateMessage = (0, utils_2.validateDate)(elecData.readingDateTime || (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd'), supply.start, lastMexDate);
        var tiers = elecData.tiers;
        if (supply.isMultiRate) {
            var offPeakTier = tiers.length &&
                tiers.find(function (_a) {
                    var timeOfUseLabel = _a.timeOfUseLabel;
                    return timeOfUseLabel === 'offpeak';
                });
            var peakTier = tiers.length &&
                tiers.find(function (_a) {
                    var timeOfUseLabel = _a.timeOfUseLabel;
                    return timeOfUseLabel === 'peak';
                });
            var offPeakError = (0, utils_2.validateInput)(offPeakTier ? offPeakTier.meterRegisterReading : null);
            var peakError = (0, utils_2.validateInput)(peakTier ? peakTier.meterRegisterReading : null);
            var multirateErrors = [];
            if (offPeakError) {
                multirateErrors.push({
                    id: ElectricityMeterReadingFormLegacy_1.ids.offpeak,
                    message: copy(offPeakError.message),
                    errorName: offPeakError.errorName,
                });
            }
            if (peakError) {
                multirateErrors.push({
                    id: ElectricityMeterReadingFormLegacy_1.ids.peak,
                    message: copy(peakError.message),
                    errorName: peakError.errorName,
                });
            }
            if (dateMessage) {
                multirateErrors.push({
                    id: ElectricityMeterReadingFormLegacy_1.ids.multiDate,
                    message: copy(dateMessage.message),
                    errorName: dateMessage.errorName,
                });
            }
            if (multirateErrors.length) {
                setErrors(multirateErrors);
                dispatch({
                    name: analytics_subjects_1.METER_READ_SUBMIT_ERROR,
                    type: 'render',
                    properties: (_a = {
                            errors: multirateErrors
                        },
                        _a[core_1.INTERNAL_EVENT_FLAG] = true,
                        _a),
                });
            }
            else {
                setData(elecData);
            }
        }
        else {
            var _d = __read(tiers, 1), tier = _d[0];
            var message = (0, utils_2.validateInput)(tier ? tier.meterRegisterReading : null, supply.meterNumOfDigits);
            var errors_1 = [];
            if (message) {
                errors_1.push({
                    id: ElectricityMeterReadingFormLegacy_1.ids.anytime,
                    message: copy(message.message, {
                        numOfDigits: supply.meterNumOfDigits,
                    }),
                    errorName: message.errorName,
                });
            }
            if (dateMessage) {
                errors_1.push({
                    id: ElectricityMeterReadingFormLegacy_1.ids.singleDate,
                    message: copy(dateMessage.message),
                    errorName: dateMessage.errorName,
                });
            }
            if (errors_1.length) {
                setErrors(errors_1);
                dispatch({
                    name: analytics_subjects_1.METER_READ_SUBMIT_ERROR,
                    type: 'render',
                    properties: (_b = {
                            errors: errors_1,
                            values: {
                                elecData: elecData,
                            }
                        },
                        _b[core_1.INTERNAL_EVENT_FLAG] = true,
                        _b),
                });
            }
            else {
                setData(elecData);
            }
        }
    };
    var handleGasSubmit = function (gasData) {
        var _a;
        var _b;
        setErrors([]);
        var reading = gasData ? gasData.gasVolume : null;
        var message = (0, utils_2.validateInput)(reading, supply.meterNumOfDigits);
        var lastMexDate = (_b = (0, utils_1.getLatestMeterExchangeReading)(readings['gas'])) === null || _b === void 0 ? void 0 : _b.readingDateTime;
        var dateMessage = (0, utils_2.validateDate)((gasData === null || gasData === void 0 ? void 0 : gasData.readingDateTime) || (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd'), supply.start, lastMexDate);
        var errors = [];
        if (message) {
            errors.push({
                id: GasMeterReadingFormLegacy_1.gasIds.gasMeterReadingId,
                message: copy(message.message, {
                    numOfDigits: supply.meterNumOfDigits,
                }),
                errorName: message.errorName,
            });
        }
        if (dateMessage) {
            errors.push({
                id: GasMeterReadingFormLegacy_1.gasIds.dateId,
                message: copy(dateMessage.message),
                errorName: dateMessage.errorName,
            });
        }
        if (errors.length) {
            setErrors(errors);
            dispatch({
                name: analytics_subjects_1.METER_READ_SUBMIT_ERROR,
                type: 'render',
                properties: (_a = {
                        errors: errors,
                        values: {
                            date: (gasData === null || gasData === void 0 ? void 0 : gasData.readingDateTime) || (0, date_fns_1.format)(new Date(), 'yyyy-MM-dd'),
                            readings: readings,
                        }
                    },
                    _a[core_1.INTERNAL_EVENT_FLAG] = true,
                    _a),
            });
        }
        else if (gasData) {
            setData(gasData);
        }
    };
    if ((supply.isSmart && !supply.isNonComms) || !supply.isActive) {
        return react_1.default.createElement(Redirect, { to: meterReads() });
    }
    if (serverSideError && data) {
        return (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READ_VALIDATION_PROMPT, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(components_1.MeterReadingValidationPrompt, { accountId: accountId, fuel: selectedFuel, data: data, apiError: apiError, apiErrorData: apiErrorData, latestActualReading: latestActualReading, isInProgress: meterReadingMutation.status === 'in-progress', isMultiRate: supply.isMultiRate, onSubmit: submit, onCancel: resetErrors, validationError: serverSideError, numOfDigits: supply.meterNumOfDigits, onImgChange: setMeterPhotoName })));
    }
    return (react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
        react_1.default.createElement("section", { id: section_ids_1.METER_READINGS_SECTION_ID, "data-testid": section_ids_1.METER_READINGS_SECTION_ID },
            react_1.default.createElement("div", null,
                react_1.default.createElement(ErrorSummaryNotification, { "data-testid": "error-summary-notification", title: supply.isMultiRate ? (react_1.default.createElement(Copy, { copyKey: "submitPageSummaryTitleMultiRate" })) : (react_1.default.createElement(Copy, { copyKey: "submitPageSummaryTitle" })), id: "error-summary", errors: errors })),
            apiError ? (react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READ_POST_ERROR, properties: (_c = {}, _c[core_1.INTERNAL_EVENT_FLAG] = true, _c) },
                react_1.default.createElement(ErrorNotification, { id: "api-error", "data-testid": "api-error" },
                    react_1.default.createElement(Copy, { copyKey: "apiError" })))) : null,
            react_1.default.createElement(Card, null,
                react_1.default.createElement(Heading1, null,
                    react_1.default.createElement(Copy, { copyKey: "submitPageHeading", values: { fuel: selectedFuel } })),
                react_1.default.createElement(SummaryList, null,
                    supply.msn ? (react_1.default.createElement(SummaryItem, { label: copy('summaryMeterSerial'), "data-testid": "meter-reading-form_msn" },
                        react_1.default.createElement(Pii, null, supply.msn))) : null,
                    supplies[selectedFuel].length > 1 ? (react_1.default.createElement(SummaryItem, { label: selectedFuel === 'gas'
                            ? copy('summarySupplyPointSerialGas')
                            : copy('summarySupplyPointSerialElec'), "data-testid": "meter-reading-form_mpxn" },
                        react_1.default.createElement(Pii, null, supply.mpxn))) : null,
                    latestActualReading && (react_1.default.createElement(SummaryItem, { label: copy('summaryLastRead', {
                            readDate: (0, date_fns_1.format)(latestActualReading.readingDateTime, 'd MMM'),
                        }) },
                        react_1.default.createElement(components_1.PreviousMeterReading, { fuel: selectedFuel, reading: latestActualReading, meterNumOfDigits: supply.meterNumOfDigits })))),
                selectedFuel === 'electricity' ? (react_1.default.createElement(components_1.ElectricityMeterReadingFormLegacy, { isMultiRate: supply.isMultiRate, currentSupply: supply, fuel: selectedFuel, isUpdating: meterReadingMutation.status === 'in-progress', onSubmit: handleElectricitySubmit, errors: {
                        peak: (0, nebula_1.getErrorMessage)(ElectricityMeterReadingFormLegacy_1.ids.peak, errors),
                        offpeak: (0, nebula_1.getErrorMessage)(ElectricityMeterReadingFormLegacy_1.ids.offpeak, errors),
                        anytime: (0, nebula_1.getErrorMessage)(ElectricityMeterReadingFormLegacy_1.ids.anytime, errors),
                        singleDate: (0, nebula_1.getErrorMessage)(ElectricityMeterReadingFormLegacy_1.ids.singleDate, errors),
                        multiDate: (0, nebula_1.getErrorMessage)(ElectricityMeterReadingFormLegacy_1.ids.multiDate, errors),
                    } })) : (react_1.default.createElement(components_1.GasMeterReadingFormLegacy, { currentSupply: supply, fuel: selectedFuel, isUpdating: meterReadingMutation.status === 'in-progress', onSubmit: handleGasSubmit, errors: {
                        gasMeterReadingId: (0, nebula_1.getErrorMessage)(GasMeterReadingFormLegacy_1.gasIds.gasMeterReadingId, errors),
                        dateId: (0, nebula_1.getErrorMessage)('gas-date', errors),
                    } })),
                react_1.default.createElement(Margin, { top: 6 },
                    react_1.default.createElement(P, null,
                        react_1.default.createElement(ButtonLooksLikeLink_1.ButtonLooksLikeLink, { onClick: function () { return (0, utils_1.scrollTo)(howToId); } },
                            react_1.default.createElement(Copy, { copyKey: "submitPageHowToRead" })))))),
        react_1.default.createElement("section", { id: howToId },
            react_1.default.createElement(Card, null,
                react_1.default.createElement(Heading1, null,
                    react_1.default.createElement(Copy, { copyKey: "submitPageHowToReadTitle" })),
                react_1.default.createElement(MeterHelp_1.MeterHelp, { supply: supply, fuelType: selectedFuel }),
                react_1.default.createElement(Margin, { top: 6 },
                    react_1.default.createElement(P, null,
                        react_1.default.createElement(ButtonLooksLikeLink_1.ButtonLooksLikeLink, { onClick: function () { return (0, utils_1.scrollTo)(section_ids_1.METER_READINGS_SECTION_ID); } },
                            react_1.default.createElement(Copy, { copyKey: "submitPageBackToRead" }))))))));
};
exports.SubmitMeterReading = SubmitMeterReading;
